var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross-Chain_icon",
    "data-name": "Cross-Chain icon",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    transform: "translate(0 32) rotate(-90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(4.077 29.636) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1.322,13.152A1.322,1.322,0,0,1,.387,10.9L8.629,2.653l-5.916.008h0a1.322,1.322,0,0,1,0-2.644L15.022,0,2.257,12.765A1.318,1.318,0,0,1,1.322,13.152Z",
    transform: "translate(9.3 0) rotate(45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1.322,13.152A1.322,1.322,0,0,1,.387,10.9L8.629,2.654l-5.916.008a1.322,1.322,0,0,1,0-2.644L15.022,0,2.257,12.765A1.318,1.318,0,0,1,1.322,13.152Z",
    transform: "translate(18.549 23.889) rotate(-135)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChain);
export default __webpack_public_path__ + "static/media/cross-chain.f80266d1.svg";
export { ForwardRef as ReactComponent };